import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import $ from 'jquery';
import {Api} from '../../../utils/Variables';

import PsContext from '../../context/PsContext';

class NavDropdownItem extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			
		}
		
	}
	
	componentDidMount(){
		
	}
	
	
	render(){
		return(
			<NavLink to={this.props.item.url} > {this.props.items.name} </NavLink>
		);
	}
	
}
export default NavDropdownItem;
